import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

/**
 * Servicio que maneja el scroll automático al inicio de una nueva pantalla
 * Se suscribe a los eventos de navegación del Router y resetea el scroll a (0, 0)
 */
@Injectable({
  providedIn: 'root'
})
export class ScrollService {
  private readonly router = inject(Router);

  constructor() {
    this.initScrollBehavior();
  }

  /**
   * Inicializa el comportamiento del scroll
   * Escucha los eventos de NavigationEnd y realiza scroll hacia arriba
   */
  private initScrollBehavior(): void {
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.scrollToTop();
      });
  }

  /**
   * Realiza scroll hacia el inicio de la página
   * Busca el contenedor de scroll (mat-sidenav-content) y luego el body
   */
  scrollToTop(): void {
    // Intenta scrollear el contenedor principal (mat-sidenav-content)
    const sidenavContent = document.querySelector('mat-sidenav-content');
    if (sidenavContent) {
      sidenavContent.scrollTop = 0;
      return;
    }

    // Fallback: scrollea el window
    window.scrollTo(0, 0);
  }
}
